import { ui } from "@/components/ui";
import { useUpdateTracker } from "@/features/trackers/api/updateTracker";
import dayjs from "dayjs";
import { PlayCircle, StopCircle } from "lucide-react";

interface Props {
	diaryId: string;
	trackerId: string | null;
	endDate: string | null;
	stopWords?: string;
	startWords?: string;
}

const PlayPauseTrackerButton = ({
	diaryId,
	trackerId,
	endDate,
	stopWords,
	startWords,
}: Props) => {
	const upsertTracker = useUpdateTracker({ diaryId: diaryId });

	if (!trackerId) {
		return null;
	}

	return (
		<>
			{endDate === null ? (
				<ui.Button
					size="lg"
					className="w-full"
					onClick={() =>
						upsertTracker.mutate({
							tracker_id: trackerId,
							end_date: dayjs().toISOString(),
						})
					}
					variant="destructive-secondary"
				>
					<StopCircle />
					{stopWords ?? "Stop"}
				</ui.Button>
			) : (
				<ui.Button
					onClick={() =>
						upsertTracker.mutate({
							tracker_id: trackerId,
							end_date: null,
						})
					}
					size="lg"
					className="w-full"
					variant="secondary"
				>
					<PlayCircle />
					{startWords ?? "Restart"}
				</ui.Button>
			)}
		</>
	);
};

export default PlayPauseTrackerButton;
